
import './App.css';
import backgroundVideo from './2122967-uhd_3840_2160_30fps.mp4'; // Adjust the path to your video

function App() {
  return (
    <div className="App">
      <video autoPlay loop muted style={videoStyle}>
        <source src={backgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      <header className="App-header">
  <p className='companyName' style={{ fontFamily: 'Times New Roman', fontSize: 75, marginTop: 350 }}>
    Oboukhov Entertainment LLC
  </p>


  <div class="container">
    {/* <div class="box">
        <h2>Our Apps</h2>
        <p>Details about our apps go here.</p>
    </div>
    <div class="box">
        <h2>Course Distribution</h2>
        <p>Details about course distribution go here.</p>
    </div> */}
    <div class="box">
    <h2>About us</h2>
<p>
    Founded in 2025 by composer and full-stack developer Arcady Oboukhov, alongside former violin instructor Elena Oboukhova, Oboukhov Entertainment LLC is a U.S.-based company specializing in website and application development, as well as the distribution of music composition courses. Our mission is to streamline the hiring process for composers and empower individuals with the tools and knowledge needed to pursue a successful career in music composition.
</p>
<p>
Oboukhov Entertainment LLC owns exclusive rights to the Arcady Oboukhov brand and maintains and owns arcadyoboukhov.com. Via that website, we strive to provide high-quality affordable music composition courses making knowledge of composition accessible to all. 
</p>
<ul>
    
    <li><strong>Discover Composers</strong>: Find the perfect composer for your needs today. Click the "Learn More" button to explore our services.</li>
</ul>

    

  </div>
</div>
<div class="container3">

    <div class="box3">
    <h2>Custom Music</h2>
    <p>
        At Oboukhov Entertainment LLC, we serve as a bridge connecting you with talented artists to deliver exceptional custom music tailored for your film, video game, or project. Our mission is to fund and empower our artists to produce high-quality, high-budget compositions that are perfectly suited for commercialization. 
    </p>
    
    <h3>Our Offerings</h3>
    <ul>
        <li><strong>Custom Music Creation</strong>: Collaborate with our artists to develop unique soundtracks that enhance your project’s narrative and emotional depth.</li>
        <li><strong>High-Quality Production</strong>: Experience top-tier production values, ensuring that every piece we create meets industry standards and captures your vision.</li>
        <li><strong>Artist Collaboration</strong>: Work directly with our diverse roster of musicians, each bringing their own style and expertise, to craft the perfect sound for your needs.</li>
        <li><strong>Safe Hiring</strong>: We ensure that music meets your standards and that payment is processed to artists successfully.</li>
    </ul>

    

    <p>
        Discover how we can help bring your vision to life with bespoke music solutions.
    </p>
    <button className="learnMoreButton" onClick={() => alert("Learn more about our services!")}>
              Learn More
            </button>
  </div>
</div>


<div class="container2">
    <div class="box2">
        <h2>Elena Oboukhova</h2>
        <h3>CEO and co-founder</h3>
        <p>Details about our apps go here.</p>
    </div>
    <div class="box2">
        <img 
            src="https://arcadyoboukhov.com/images/face/arcadyoboukhov_in_a_park2.jpg" 
            alt="Arcady Oboukhov" 
            style={{ width: '50%', height: 'auto', borderRadius: '8px', marginBottom: '16px' }} 
        />
        <h2>Arcady Oboukhov</h2>
        <h3>Lead Programmer and Co-founder</h3>
        <p>Details about course distribution go here.</p>
    </div>
   
</div>

</header>

    </div>
  );
}

const videoStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: -1, // To keep the video behind other content
};

export default App;
